// eslint-disable-next-line spire/export-chain
import Zone from "@insite/client-framework/Components/Zone";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

const enum fields {
    cssClass = "cssClass",
}

interface Props extends PageProps {
    fields: {
        [fields.cssClass]: string;
    };
}

export interface GeneralLandingPageStyle {
    cutomPageContainer?: InjectableCss;
    ResourceContainer?: GridContainerProps;
    ResourceListItemContainer?: GridItemProps;
    ResourceimgContainer?: GridItemProps;
    GeneralLandingItemContainer?: GridItemProps;
}

export const styles: GeneralLandingPageStyle = {
    cutomPageContainer: {
        css: css`
            max-width: 100% !important;
            padding: 0 !important;
            h3 {
                padding-bottom: 8px;
            }
            &.ios500 {
                .glpWrapper {
                    color: #33333a;
                    h2 {
                        margin-bottom: 0;
                        font-size: 30px;
                        line-height: 36px;
                    }
                    > div {
                        font-size: 16px;
                        line-height: 24px;
                        padding-bottom: 56px;
                        font-weight: 300;
                        letter-spacing: 0;
                    }
                    h3 {
                        font-size: 21px;
                        font-weight: 600;
                        letter-spacing: 0;
                        line-height: 25px;
                    }
                    .quoteWrapper {
                        padding-bottom: 73px;
                        font-size: 26px;
                        font-weight: 500;
                        letter-spacing: 0;
                        line-height: 34px;
                    }
                    > p {
                        margin-bottom: 0;
                    }
                }
            }
        `,
    },
    ResourceContainer: {
        gap: 0,
        css: css`
            wdith: 100%;
            max-width: 1140px;
            margin: 0 auto;
        `,
    },
    ResourceimgContainer: {
        width: 12,
        css: css``,
    },
    ResourceListItemContainer: {
        width: [12, 12, 12, 12, 12],
        css: css`
            margin-top: -63px !important;
            background-color: #fff;
            padding: 0;
            margin-bottom: 29px !important;
            margin-left: auto !important;
            margin-right: auto !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: 0px !important;
                            margin-bottom: 0px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                        `,
                        css`
                            margin-top: -63px !important;
                            margin-bottom: 29px !important;
                        `,
                    ],
                    "min",
                )}
        `,
    },
};
const IntArchivedDocumentsPage = (props: Props) => {
    const {
        fields: { cssClass },
        id,
    } = props;
    return (
        <Page {...styles.cutomPageContainer} className={cssClass}>
            <GridItem {...styles.ResourceimgContainer}>
                <Zone contentId={id} zoneName="Content1" />
            </GridItem>
            <Zone contentId={id} zoneName="Content2" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: IntArchivedDocumentsPage,
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        fieldDefinitions: [
            {
                name: fields.cssClass,
                displayName: "Add CSS Class",
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },
        ],
        pageType: "Content",
    },
};

export default pageModule;
